import api, { request } from '../../../../api';
import { IStore } from '../../../index';
import { IEventItem } from '../store';
import { IEventsActionResponse } from '../Utils/TEventsActionResponse';

export const get = async (
  state: IStore,
  eventId: string,
  force?: boolean
): Promise<IEventsActionResponse> => {
  if (state.events[Number(eventId)] && !force) {
    return { events: state.events };
  }
  const response = await request.get(`${api.events}${eventId}`);
  if (response.error) {
    return { errors: { events: { msg: 'Error retrieving the Event.' } } };
  }

  const event: IEventItem = response;
  return {
    events: {
      ...state.events,
      [event.id]: {
        ...event,
        enrollments: event.enrollments || []
      }
    }
  };
};
